module.exports = __webpack_public_path__ + "static/media/syringue.d82cc92c.svg";